module.exports = __webpack_public_path__ + "img/002-like.bbd2328e.png";